import { render, staticRenderFns } from "./EnpsAuthorTable.vue?vue&type=template&id=117822b0"
import script from "./EnpsAuthorTable.vue?vue&type=script&lang=js"
export * from "./EnpsAuthorTable.vue?vue&type=script&lang=js"
import style0 from "./EnpsAuthorTable.vue?vue&type=style&index=0&id=117822b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports